var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import isNil from 'common/support/isNil';
import { JobillaCompanyIntegrations, } from 'packages/candidate_export/integrations/JobillaCompanyIntegrations';
var CompanyIntegrationAssets = /** @class */ (function (_super) {
    __extends(CompanyIntegrationAssets, _super);
    function CompanyIntegrationAssets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logoUrl = null;
        _this.iconUrl = null;
        _this.iconBlackUrl = null;
        return _this;
    }
    return CompanyIntegrationAssets;
}(Entity));
var ExportSystem = /** @class */ (function (_super) {
    __extends(ExportSystem, _super);
    function ExportSystem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.category = null;
        _this.id = null;
        _this.label = null;
        _this.assets = new CompanyIntegrationAssets();
        return _this;
    }
    Object.defineProperty(ExportSystem.prototype, "safeLabel", {
        get: function () {
            return this.label || this.id;
        },
        enumerable: false,
        configurable: true
    });
    ExportSystem.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        var integration = JobillaCompanyIntegrations
            .find(function (integration) { return integration.id === jsonData.tool_id; });
        if (isNil(integration)) {
            this.id = jsonData.tool_id;
            return this;
        }
        this.id = integration.id;
        this.label = integration.label;
        this.assets = EntityBuilder.buildOne(CompanyIntegrationAssets, integration.assets);
        return this;
    };
    __decorate([
        Type(CompanyIntegrationAssets),
        __metadata("design:type", CompanyIntegrationAssets)
    ], ExportSystem.prototype, "assets", void 0);
    return ExportSystem;
}(Entity));
export { ExportSystem };
